import React from 'react';
import './hero.scss';
import logo from '../../assets/logo.png';
import videoL from '../../assets/heroD.mp4';
import videoS from '../../assets/heroM.mp4';

function Hero() {
  return (
    <section className="hero">
      <img src={logo} className="hero__logo" alt="Johnson & Johnson" />
      <div className="hero__bg">
        <video
          muted
          autoPlay
          loop
          playsInline
          className="hero__bg__videoloop hero__bg__videoloop--d"
        >
          <source src={videoL} type="video/mp4" />
          Your browser does not support HTML video.
        </video>
        <video
          muted
          autoPlay
          loop
          playsInline
          className="hero__bg__videoloop hero__bg__videoloop--m"
        >
          <source src={videoS} type="video/mp4" />
          Your browser does not support HTML video.
        </video>
      </div>
      <div className="hero__text">
        <h1>Three Journeys With Treatment-Resistant Depression, Three Stories of Resilience</h1>
        <h2>
          Having the courage to speak out about one’s journey with depression is daunting. Here are
          three people who do just that — and share the support they finally found.
        </h2>
      </div>
    </section>
  );
}

export default Hero;
